import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../utils/redux';

export const consts = createReqConsts('board', 'reqInvitePatient', ['CLEAR']);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'patient_invitations',
  type: 'post',
});

const reqReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case consts.CLEAR:
      return initialState;

    default:
      return reqReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/board/reqInvitePatient.js